import React from "react";
import { newModelWith } from "../common/models";


export function notificationWith(values = {}) {
    const schema = {
        communicator: React.PropTypes.shape({
            name: React.PropTypes.string,
            companyName: React.PropTypes.string
        }),
        communicationTimestamp: React.PropTypes.string,
        communicationMethod: React.PropTypes.string,
        presentations: React.PropTypes.arrayOf(React.PropTypes.shape({
            productionTimestamp: React.PropTypes.string,
            validityPeriod: React.PropTypes.string,
            legs: React.PropTypes.arrayOf(React.PropTypes.shape({
                referenceData: React.PropTypes.shape({
                    companyName: React.PropTypes.string,
                    isin: React.PropTypes.string
                }),
                direction: React.PropTypes.string,
                derivativeDescription: React.PropTypes.string,
                targetPrice: React.PropTypes.string,
                marketPrice: React.PropTypes.string
            }))
        }))
    };
    const defaults = {};

    return newModelWith(values, defaults, schema);
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/portal/portalModels.js
 **/